<section class="h-100">
  <div class="login d-flex flex-column flex-md-row justify-content-between align-items-center">
    <div class="w-100 w-md-50 login__divider">
      <div
        class="login__cover d-flex align-items-center justify-content-center p-5 p-md-3"
        [ngStyle]="loginCoverStyle()"
        (mousemove)="handleBackgroundPointerMove($event)"
        (mouseleave)="resetBackgroundPointer()">
        <div
          class="login__cover__background"
          [class.login__cover__background--visible]="activeBackgroundLayer() === 'a'"
          [ngStyle]="backgroundLayerAStyle()"></div>
        <div
          class="login__cover__background"
          [class.login__cover__background--visible]="activeBackgroundLayer() === 'b'"
          [ngStyle]="backgroundLayerBStyle()"></div>
        <div class="orb-effect"></div>
        <div class="orb-effect-2"></div>
        <img
          [src]="logoUrl"
          alt="Legatus Growth Partner"
          title="Legatus Growth Partner"
          class="login__cover__logo img-fluid" />
        <app-login-background-designer
          [visible]="showBackgroundDesigner()"
          (settingsChange)="handleBackgroundSettingsChange($event)"></app-login-background-designer>
      </div>
    </div>
    <div class="w-100 w-md-50 login__divider">
      <div class="d-flex justify-content-end me-3 m-3">
        <div class="pe-1">
          <app-select-language></app-select-language>
        </div>
      </div>
      @if (switchingSession(); as switching) {
        <!-- Troca de sessão por ?token= ou ?restore=1 (card 3804): nada de formulário preenchido na tela. -->
        <div class="login__switching" role="status" aria-live="polite">
          <app-cog-loading-spinner [size]="72"></app-cog-loading-spinner>
          <h2 class="login__switching__title">{{ switching.title }}</h2>
          @if (switching.message) {
            <p class="login__switching__message">{{ switching.message }}</p>
          }
        </div>
      } @else {
        <ng-container [ngSwitch]="formMode">
          <app-login-form
            *ngSwitchCase="_login"
            [companyId]="companyId"
            [tenantId]="tenantId"
            (sendFormModeChange)="handleFormMode($event)"></app-login-form>
          <app-password-form
            *ngSwitchCase="_passwordRecovery"
            (sendFormModeChange)="handleFormMode($event)"></app-password-form>
          <app-first-access-form
            *ngSwitchCase="_firstAccess"
            (sendFormModeChange)="handleFormMode($event)"></app-first-access-form>
        </ng-container>
      }
    </div>
  </div>
</section>

<app-tenant-company-login-selection></app-tenant-company-login-selection>
